<template>
  <div>
     <center>
    <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-card>
              <v-img
                @click="Home()"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-divider
              class="mx-0"
              style="background-color: #ffffff"
            ></v-divider>

            <v-card-title class="lighten-5">
                  {{dataItem.masWelfareTypelName}}
                </v-card-title>

            <div>
              <v-expansion-panels
                v-model="panel"
                multiple
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>เงื่อนไข</v-expansion-panel-header>
                  <v-expansion-panel-content>
                  <h6 type="text" class="text-left" v-html="dataItem.masWelfareConditions"></h6>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>เอกสารประกอบ</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <h6 type="text" class="text-left" v-html="dataItem.masWelfareDocument"></h6>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>

            <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
          <v-subheader>แนบไฟล์ เอกสารประกอบเพื่อการใช้สิทธิ์</v-subheader>
          <v-file-input
            v-model="files"
            show-size
            accept="image/*,.pdf"
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            :rules="imageRules"
            outlined
            dense
            required
          ></v-file-input>
          <v-file-input
            v-model="files2"
            show-size
            accept="image/*,.pdf"
            :rules="imageRules"
            outlined
            dense
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            required
          ></v-file-input>
          <v-file-input
            v-model="files3"
            show-size
            accept="image/*,.pdf"
            :rules="imageRules"
            outlined
            dense
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            required
          ></v-file-input>
          <v-file-input
            v-model="files4"
            show-size
            accept="image/*,.pdf"
            :rules="imageRules"
            outlined
            dense
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            required
          ></v-file-input>
          <v-file-input
            v-model="files5"
            show-size
            accept="image/*,.pdf"
            :rules="imageRules"
            outlined
            dense
            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
            required
          ></v-file-input>

                  <v-btn
                    :disabled="!files"
                    :loading="loading"
                    small
                    color="success"
                  @click="addData()"
                  >
                    บันทึกข้อมูล
                  </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
     </center>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date

export default {
  components: {
    name: 'Info',
    moment
  },
  data () {
    return {
      value: 1,
      PK: '',
      dataReady: true,
      panel: [0, 1],
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      year: '',
      month: '',
      day: '',
      session: this.$session.getAll(),
      formAdd: [],
      dataItem: [],
      files: null,
      files2: null,
      files3: null,
      files4: null,
      files5: null,
      loading: false,
      imageRules: [
        value => !value || value.size < 5000000 || 'size should be less than 5 MB!'
      ]
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    let date = new Date()
    this.year = moment().format('YYYY')
    this.month = date.getMonth() + 1
    this.day = date.getDate()
    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/HomeWelfare')
    },
    async getData () {
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_welfare_type/getDataMaternity'
        )
        .then(async (response) => {
          this.dataReady = false
          this.dataItem = response.data[0]
          console.log('dataItem', this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async addData () {
      this.dataReady = true
      this.loading = true
      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.day = this.day !== '' ? this.day : moment().format('D')
      console.log('day', this.day)
      console.log('month', this.month)
      console.log('year', this.year)
      console.log('date', this.year + '-' + this.month + '-' + this.day)
      console.log('profile', this.profile)
      console.log(this.files)

      if (this.files) {
        await this.fileupload()
      }
      if (this.files2) {
        await this.fileupload2()
      }
      if (this.files3) {
        await this.fileupload3()
      }
      if (this.files4) {
        await this.fileupload4()
      }
      if (this.files5) {
        await this.fileupload5()
      }

      let ds = {
        empCode: this.profile.empCode,
        welfare_year: this.year,
        welfare_month: this.month,
        welfare_day: this.day,
        welfare_date: this.year + '-' + this.month + '-' + this.day,
        welfare_status: 'draft',
        welfareRequest: 'สวัสดิการคลอดบุตร',
        welfareAmount: '2000',
        welfareFile: this.formAdd.welfareFile,
        welfareFile2: this.formAdd.welfareFile2,
        welfareFile3: this.formAdd.welfareFile3,
        welfareFile4: this.formAdd.welfareFile4,
        welfareFile5: this.formAdd.welfareFile5,
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName

      }
      console.log('ds', ds)
      this.addDataSubmit(ds)
      this.loading = false
    },
    async addDataSubmit (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/welfare/add",
          ds
        )
        .then(async (response) => {
          // this.$swal('เรียบร้อย', 'บันทึกข้อมูล เรียบร้อย', 'success')
          this.dataReady = false
          await this.linenotify(ds)
          await this.setUpBeforeSendLine(ds)
          await this.$router.push('/Liff/QuestSuccess')
          this.cleanData()
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      params.append('profile', _this.profile)
      console.log('this.files', _this.files)
      console.log('this.files', _this.files.size)
      console.log('URL', _this.DNS_IP_UPLOAD + '/upload')
      console.log('params', params)

      if (_this.files.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.formAdd.welfareFile = _this.DNS_IP_UPLOAD + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.welfareFile = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files = null
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files = null
      }
    },
    async fileupload2 () {
      const _this = this
      let params = new FormData()

      if (_this.files2.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files2)
        params.append('profile', _this.profile)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              // console.log('file2', response)
              _this.formAdd.welfareFile2 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile2 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files2 = null
        }

        console.log('this.files2', _this.formAdd.welfareFile2)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files2 = null
      }
    },
    async fileupload3 () {
      const _this = this
      let params = new FormData()

      if (_this.files3.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files3)
        params.append('profile', _this.profile)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              // console.log('file2', response)
              _this.formAdd.welfareFile3 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile3 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files3 = null
        }

        console.log('this.files3', _this.formAdd.welfareFile3)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files3 = null
      }
    },
    async fileupload4 () {
      const _this = this
      let params = new FormData()

      if (_this.files4.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files4)
        params.append('profile', _this.profile)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              // console.log('file2', response)
              _this.formAdd.welfareFile4 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile4 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files4 = null
        }

        console.log('this.files4', _this.formAdd.welfareFile4)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files4 = null
      }
    },
    async fileupload5 () {
      const _this = this
      let params = new FormData()

      if (_this.files5.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files5)
        params.append('profile', _this.profile)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              // console.log('file2', response)
              _this.formAdd.welfareFile5 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile5 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files5 = null
        }

        console.log('this.files5', _this.formAdd.welfareFile5)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files5 = null
      }
    },
    async linenotify (dt) {
      var massageNoti = 'ขอ' + dt.welfareRequest +
            '\nชื่อพนักงาน : ' + this.profile.empFull_NameTH +
            '\nแผนก : ' + this.profile.masDepartmentName +
            '\nสาขา : ' + this.profile.masBranchName +
            '\nบริษัท : ' + this.profile.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + this.profile.empTel
      let ds = {
        token: 'ykOxnleuJDAAnR6CwdI98b7PJYidormK5ZdvOApt54Q', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    },
    async setUpBeforeSendLine (item) {
      var payload = [
        {
          'type': 'flex',
          'altText': 'ขอสวัสดิการ',
          'contents': {
            'type': 'bubble',
            'header': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'text',
                  'text': 'แจ้งเตือนการร้องขอสวัสดิการ',
                  'offsetBottom': 'none',
                  'offsetTop': 'xs',
                  'weight': 'bold',
                  'position': 'relative',
                  'align': 'start',
                  'wrap': true
                }
              ],
              'offsetBottom': 'md',
              'backgroundColor': '#FFB8A1'
            },
            'body': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'box',
                  'layout': 'horizontal',
                  'contents': [
                    {
                      'type': 'box',
                      'layout': 'vertical',
                      'contents': [
                        {
                          'type': 'image',
                          'url': 'https://api.betaskthai.com/upload/static/upload/Welfare/2022_09/EMP20218193_2022_09_30_16_49_50.png',
                          'size': 'full',
                          'margin': 'lg'
                        }
                      ],
                      'cornerRadius': '100px',
                      'width': '72px',
                      'height': '72px'
                    },
                    {
                      'type': 'box',
                      'layout': 'vertical',
                      'contents': [
                        {
                          'type': 'text',
                          'contents': [
                            {
                              'type': 'span',
                              'text': 'รอตรวจสอบเอกสารและผู้จัดการอนุมัติ',
                              'weight': 'bold',
                              'color': '#000000'
                            },
                            {
                              'type': 'span',
                              'text': '|'
                            }
                          ],
                          'size': 'sm',
                          'wrap': true
                        },
                        {
                          'type': 'text',
                          'text': 'hello, world',
                          'contents': [
                            {
                              'type': 'span',
                              'text': item.welfareRequest,
                              'color': '#D81B60'
                            }
                          ]
                        },
                        {
                          'type': 'text',
                          'text': this.profile.empFull_NameTH
                        }
                      ]
                    }
                  ],
                  'spacing': 'xl',
                  'paddingAll': '20px',
                  'paddingTop': 'xs',
                  'paddingBottom': 'xs'
                },
                {
                  'type': 'separator'
                },
                {
                  'type': 'box',
                  'layout': 'baseline',
                  'contents': [
                    {
                      'type': 'text',
                      'text': 'วันที่ทำรายการ',
                      'flex': 1,
                      'size': 'sm',
                      'color': '#aaaaaa',
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': item.welfare_date,
                      'size': 'sm',
                      'color': '#666666',
                      'wrap': true,
                      'flex': 1,
                      'align': 'center'
                    }
                  ],
                  'paddingTop': 'md'
                }
              ],
              'paddingAll': '0px',
              'offsetTop': 'xs',
              'spacing': 'none'
            },
            'footer': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'button',
                  'action': {
                    'type': 'uri',
                    'label': 'ตรวจสอบสถานะ',
                    'uri': 'http://linecorp.com/'
                  },
                  'style': 'primary',
                  'color': '#FFB8A1'
                }
              ]
            }
          }
        }
      ]
      await this.sendLinePush(payload, this.profile.userLineuserId)
      this.dataReady = false
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(
        // eslint-disable-next-line quotes
        this.DNS_IP + "/line/push_message",
        dt,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
    },
    cleanData () {
      this.files = null
      this.files2 = null
      this.files3 = null
      this.files4 = null
      this.files5 = null
    }
  }
}
</script>
<style scope>
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/WelfareMaternity.vue